// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"e6e0b7ba","138":"e2e89617","270":"dd666a81","404":"7dae82bf","488":"b2a64b34","545":"b2905896","580":"ac448ee5","686":"8a3211c7","706":"44ba4c26","728":"748374d7","801":"94c55834","888":"62069d05"}[chunkId] + ".chunk.js";
};